<div class="container-information">
  <div class="title">
    <h1>Información de tu negocio</h1>
    <p style="text-align: center; max-width: 633px">
      Cárgale a tu asistente la información que tendrá para responder a tus clientes.
      <span class="mobile-line-break">
        <strong>Sugerencias:</strong> Información de tu negocio, stock y precios de productos,
        preguntas frecuentes, etc.
      </span>
    </p>
  </div>
  <div class="cards">
    <div (click)="setSubStep('upload')" class="card">
      <div class="content-card">
        <div><i class="pi archive-icon"></i></div>
        <div class="text">
          <h2>Archivo</h2>
          <span style="line-height: 24px"
            >Importa documentos tipo PDF, Word, Excel, Texto o CSV.</span
          >
        </div>
      </div>
    </div>
    <div (click)="setSubStep('web')" class="card">
      <div class="content-card">
        <div><i class="pi globe-icon"></i></div>
        <div class="text">
          <h2>Tu sitio web</h2>
          <span style="line-height: 24px"
            >Ingresa una URL y se cargarán todas las páginas incluidas.</span
          >
        </div>
      </div>
    </div>
    <div *ngIf="showGoogleDriveOption" (click)="setSubStep('drive')" class="card">
      <div class="content-card">
        <div><img src="/assets/icons/drive.svg" alt="drive"></div>
        <div class="text">
          <h2>Google Drive</h2>
          <span style="line-height: 24px">Conecta tu Drive para cargar archivos.</span>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="button" *ngIf="showBackButton">
  <globot-button
    class="expand-on-mobile"
    text="Volver"
    styleClass="secondary"
    icon="pi pi-arrow-left"
    iconPosition="left"
    style="width: 100%; display: flex; justify-content: start; margin-top: 30px"
    (clickEvent)="back()"
  ></globot-button>
</div>
